import BinaryStateButton from "components/BinaryStateButton";
import { IconCollection } from "components/Icon/IconCollection";
import Tooltip from "components/Tooltip/Tooltip";
import { setPinned } from "containers/QuickAccess/QuickAccess.service";
import { getUserData } from "containers/Auth/Auth.selectors";
import { getRecordUserData } from "containers/Resources/Resources.selectors";
import { isEmpty } from "lodash";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

export const PinPopover = ({
    resourceData,
    style,
}: {
    resourceData: any;
    style?: React.CSSProperties;
}) => {
    const dispatch = useDispatch();
    const recordUserSelector = useCallback(
        (state) => {
            const projectOrBundleId = resourceData?.project_id ?? resourceData?.bundle_id;
            const recordId = resourceData?.id;

            return getRecordUserData(state, recordId, projectOrBundleId);
        },
        [resourceData?.bundle_id, resourceData?.id, resourceData?.project_id]
    );
    const recordUser = useSelector(recordUserSelector);
    const isPinned = recordUser.isPinned ?? false;

    const userData = useSelector(getUserData);
    const userId: string | undefined = userData?.identity_id;

    // Pinning targets the record's RECORD_USER row (`recordUser.id`, from the
    // parent container's opened/pinned lists). That row can be missing or
    // stale (the backend drops the oldest unpinned rows), so pinning also
    // passes the record id and the user's identity: setPinned creates the
    // row when it is missing. Unpinning needs the row, which a pinned record
    // always has.
    const isReady =
        !isEmpty(resourceData) &&
        resourceData?.deleted_at == null &&
        (isPinned ? recordUser.id != null : !!userId);

    return (
        <Tooltip overlay={isPinned ? "Unpin from sidebar" : "Pin to sidebar"} overlayStyle={style}>
            <BinaryStateButton
                trueStateIcon={IconCollection.pinOffOutline}
                falseStateIcon={IconCollection.pinOutline}
                state={isPinned}
                onClick={() => {
                    if (!isReady) return;
                    setPinned(dispatch, recordUser.id, !isPinned, {
                        recordId: resourceData?.id,
                        userId,
                    });
                }}
                className="pinButton"
                disabled={!isReady}
            />
        </Tooltip>
    );
};
